// extracted by mini-css-extract-plugin
export default {"metadata":"Metadata-metadata-OpuUq Card-card-aoesq","name":"Metadata-name-LB94N","section":"Metadata-section-GlYvh"};